import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
if (window.location.hostname === "one-crm-admin") {
  axios.defaults.baseURL = "http://onecrm_nginx/api/admin";
}
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["Accept"] = "application/json";

